import { UserActionTypes, UserActions } from '../actions/user.actions';
import { User } from '@digitaix/types';

export function authUserReducer(
  state = null,
  action: UserActions,
): User | null | false {
  switch (action.type) {
    case UserActionTypes.SetUser:
      return action.user;

    default:
      return state;
  }
}
